<template>
  <div>

      <Banner></Banner>

      <BrandsLogos></BrandsLogos>

      <About></About>

      <Vistion></Vistion>

      <Advantages></Advantages>

      <WhyChooseUs></WhyChooseUs>

      <TypeDiv></TypeDiv>

      <Portfolio></Portfolio>

      <Const></Const>

  </div>
</template>

<script>
import Banner from '../../components/WebDevelopment/WordPressDevelopment/Banner.vue'
import Vistion from '../../components/WebDevelopment/WordPressDevelopment/Vistion.vue'
import Advantages from '../../components/WebDevelopment/WordPressDevelopment/Advantages.vue'
import WhyChooseUs from '../../components/WebDevelopment/WordPressDevelopment/WhyChooseUs.vue'
import BrandsLogos from '../../components/AssetComponents/BrandsLogos.vue'
import Portfolio from '../../components/Home/Portfolio.vue'
import About from '../../components/WebDevelopment/WordPressDevelopment/About.vue'
import TypeDiv from '../../components/Home/TypeDiv.vue'
import Const from '../../components/AssetComponents/Const.vue'

export default {
    components:{
        Banner,
        BrandsLogos,
        About,
        TypeDiv,
        WhyChooseUs,
        Portfolio,
        Const,
        Vistion,
        Advantages
    }
}
</script>


<style>

</style>